/* eslint-disabled */

export default class DataTypeExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
